import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues() {
  return {
    codigorecuperacion: "",
  };
}

export function validationSchema() {
  return Yup.object({
    codigorecuperacion: Yup.string().required(` ${campo_obligatorio} `),
  });
}
